"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _tradeBanner = _interopRequireDefault(require("../../components/trade/trade-banner.vue"));
var _rightNav = _interopRequireDefault(require("../../components/trade/right-nav.vue"));
var _goodsList = _interopRequireDefault(require("../../components/trade/goods-list.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _util = _interopRequireDefault(require("../../assets/static/js/utils/util.js"));
var _paging = _interopRequireDefault(require("@/components/paging"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _api = _interopRequireDefault(require("../../api/api"));
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?91911f14dbe07f4289cb026e58a3b3d8";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
var _default = exports.default = {
  name: 'goods',
  components: {
    tradeBanner: _tradeBanner.default,
    rightNav: _rightNav.default,
    goodsList: _goodsList.default,
    paging: _paging.default,
    footNav: _footNav.default
  },
  data: function data() {
    return {
      name: '',
      page: 1,
      goodsTotal: 0,
      loaded: false,
      start: '',
      startValue: [],
      startCitys: _appCitysData.default.cityData,
      end: '',
      endValue: [],
      endCitys: _appCitysData.default.cityData,
      carTypeId: '',
      carTypes: [],
      goodsTypeId: '',
      goodsTypes: [],
      timeValue: '',
      goodsData: [],
      sortConfig: {
        sortFlag: true,
        arrivalTimeActive: false,
        arrivalTimeAsc: false,
        releaseTimeActive: false,
        releaseTimeAsc: false
      },
      centerAdvertise: '',
      rightAdverData: [],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time < new Date() - 24 * 60 * 60 * 1000;
        }
      },
      tabList: [{
        name: '货源查询',
        url: 'goods'
      }, {
        name: '车源查询',
        url: 'cars'
      }, {
        name: '发布车源',
        url: 'pubcars'
      }, {
        name: '发布货源',
        url: 'pubgoods'
      }]
    };
  },
  created: function created() {
    this.loadGoodsData();
    this.loadGoodsTypeData();
    this.loadCarTypeData();
    this.loadAdvertiseData();
  },
  methods: {
    //货源查询
    loadGoodsData: function () {
      var _loadGoodsData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, loadInstance, sortType, paramstr, params, _yield$Api$apiGetGood, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              sortType = {};
              if (!_util.default.isEmpty(that.sortConfig.arrivalTimeActive)) {
                sortType = {
                  arrivalTime: that.sortConfig.arrivalTimeAsc == true ? 'ASC' : 'DESC'
                };
              }
              if (!_util.default.isEmpty(that.sortConfig.releaseTimeActive)) {
                sortType = {
                  releaseTime: that.sortConfig.releaseTimeAsc == true ? 'ASC' : 'DESC'
                };
              }
              paramstr = {
                "startLocation": that.start,
                "endLocation": that.end,
                "goodsTypeIdInt": that.goodsTypeId,
                "startGoodsWeight": "",
                "endGoodsWeight": "",
                "arrivalTime": that.timeValue,
                "vtId": _util.default.isEmpty(that.carTypeId) ? 0 : that.carTypeId,
                "sortType": JSON.stringify(sortType)
              };
              params = {
                pageno: that.page,
                pagesize: that.$root.pageSize,
                paramstr: JSON.stringify(paramstr)
              };
              _context.next = 9;
              return _api.default.apiGetGoodsData(params);
            case 9:
              _yield$Api$apiGetGood = _context.sent;
              data = _yield$Api$apiGetGood.data;
              loadInstance.close();
              that.loaded = true;
              that.goodsData = data.proData.content;
              that.goodsTotal = data.proData.totalElements;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadGoodsData() {
        return _loadGoodsData.apply(this, arguments);
      }
      return loadGoodsData;
    }(),
    //获取货物类型
    loadGoodsTypeData: function () {
      var _loadGoodsTypeData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, _yield$Api$apiGetGood2, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return _api.default.apiGetGoodsTypeData();
            case 3:
              _yield$Api$apiGetGood2 = _context2.sent;
              data = _yield$Api$apiGetGood2.data;
              that.goodsTypes = data.proData;
              //  console.log('goodsTypes', proData);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadGoodsTypeData() {
        return _loadGoodsTypeData.apply(this, arguments);
      }
      return loadGoodsTypeData;
    }(),
    //获取车辆类型
    loadCarTypeData: function () {
      var _loadCarTypeData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, _yield$Api$apiGetCarT, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              _context3.next = 3;
              return _api.default.apiGetCarTypeData();
            case 3:
              _yield$Api$apiGetCarT = _context3.sent;
              data = _yield$Api$apiGetCarT.data;
              that.carTypes = data.proData;
              //  console.log('carTypes', proData);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadCarTypeData() {
        return _loadCarTypeData.apply(this, arguments);
      }
      return loadCarTypeData;
    }(),
    //获取广告
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, userInfo, _yield$Api$apiGetAdve, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this; // session替换成cookie
              userInfo = (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')) : ''; // var userInfo = JSON.parse(window.sessionStorage.getItem('user'))
              _context4.next = 4;
              return _api.default.apiGetAdvertiseData({
                showType: 'PC_GS_LIST',
                userId: userInfo ? userInfo.usid : ''
              });
            case 4:
              _yield$Api$apiGetAdve = _context4.sent;
              data = _yield$Api$apiGetAdve.data;
              that.rightAdverData = data.proData.filter(function (item) {
                return item.showPosition != 'CENTER';
              });
              that.centerAdvertise = data.proData.filter(function (item) {
                return item.showPosition.match('CENTER');
              });
              console.log('adverdata:', that.rightAdverData);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }(),
    //选择出发城市
    startCityChange: function startCityChange(value) {
      if (value.length > 0 && (value[0].indexOf('台湾') >= 0 || value[0].indexOf('香港特别行政区') >= 0 || value[0].indexOf('澳门特别行政区') >= 0 || value[0].indexOf('钓鱼岛') >= 0)) {
        this.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        this.startValue = [];
        value = [];
        return;
      }
      var startStr = value.join('/');
      this.start = startStr.replace(/\/全省/g, '');
      this.start = startStr.replace(/\/全市/g, '');
      // console.log("startArr:", value);
      // console.log("start:", this.start);
    },
    //选择到达城市
    endCityChange: function endCityChange(value) {
      if (value.length > 0 && (value[0].indexOf('台湾') >= 0 || value[0].indexOf('香港特别行政区') >= 0 || value[0].indexOf('澳门特别行政区') >= 0 || value[0].indexOf('钓鱼岛') >= 0)) {
        this.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        this.endValue = [];
        value = [];
        return;
      }
      var endStr = value.join('/');
      this.end = endStr.replace(/\/全省/g, '');
      this.end = endStr.replace(/\/全市/g, '');
      //  console.log("endArr:", value);
      //  console.log("end:", this.end);
    },
    //交换起始地目的地	
    clickToExchangeCity: function clickToExchangeCity() {
      var tempCity = this.start;
      this.start = this.end;
      this.end = tempCity;
      //选择框的值也要进行交换
      var tempValue = this.startValue;
      this.startValue = this.endValue;
      this.endValue = tempValue;
      // console.log("e-start", this.start, "e-end:", this.end);
      // console.log("e-startValue:", this.startValue, "e-endValue:", this.endValue);
    },
    //选择货物类型、车辆类型、装车时间
    handleChange: function handleChange(value) {
      console.log("cahngeValue:", value);
      console.log("goodsTypeId:" + this.goodsTypeId + " carTypeId:" + this.carTypeId + " time:" + this.timeValue);
    },
    //搜索
    clickToSearch: function clickToSearch() {
      if (!this.checkUserLogin()) return;
      this.page = 1;
      this.loadGoodsData();
    },
    // 检查用户登录状态
    checkUserLogin: function checkUserLogin() {
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        this.toLogin();
        return false;
      }
      return true;
    },
    // 未登录弹出登录窗
    toLogin: function toLogin() {
      var that = this;
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        that.$root.dialogFormVisible = true;
      }
    },
    // 重置
    regest: function regest() {
      this.start = '';
      this.startValue = [];
      this.end = '';
      this.endValue = [];
      this.carTypeId = '';
      this.goodsTypeId = '';
      this.timeValue = '';
      this.page = 1;
      this.loadGoodsData();
    },
    //页面切换
    pageChange: function pageChange(value) {
      this.page = value.curPage;
      this.loadGoodsData();
    },
    //排序
    clickToSortByArrivalTime: function clickToSortByArrivalTime() {
      this.sortConfig.arrivalTimeAsc = !this.sortConfig.arrivalTimeAsc;
      this.sortConfig.arrivalTimeActive = true;
      this.sortConfig.releaseTimeActive = false;
      this.loadGoodsData();
      // console.log("pageValue:");
    },
    clickToSortByReleaseTime: function clickToSortByReleaseTime() {
      this.sortConfig.releaseTimeAsc = !this.sortConfig.releaseTimeAsc;
      this.sortConfig.arrivalTimeActive = false;
      this.sortConfig.releaseTimeActive = true;
      this.loadGoodsData();
    },
    tabChange: function tabChange(url) {
      this.$router.push({
        name: url
      });
    }
  }
};